/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of the completed occurrence.
 */
export const OccurrenceStatus = {
  Pending: "pending",
  Failed: "failed",
  Completed: "completed",
} as const;
/**
 * Status of the completed occurrence.
 */
export type OccurrenceStatus = ClosedEnum<typeof OccurrenceStatus>;

/** @internal */
export const OccurrenceStatus$inboundSchema: z.ZodNativeEnum<
  typeof OccurrenceStatus
> = z.nativeEnum(OccurrenceStatus);
/** @internal */
export const OccurrenceStatus$outboundSchema: z.ZodNativeEnum<
  typeof OccurrenceStatus
> = OccurrenceStatus$inboundSchema;
